import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import {
  Input,
  Select,
  Form,
  Switch,
  Button,
  Upload,
  message,
  Spin,
  Popconfirm,
  Typography
} from 'antd';
import ProfileImage from '../patients/Modals/ProfileImage';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { getUser } from './actions/users';
const { Option } = Select;
const PT = 'pt';
const GA = 'ga';

const getBillingRole = role => {
  if (!role) return '';

  switch (role.toLowerCase()) {
    case 'pt':
      return 'Provider';

    case 'pta':
      return 'Provider Assistant';

    case 'tech':
      return 'Technician';

    default:
      return role;
  }
};

function UserForm(props) {
  const { onSubmit, uploadImage, submitting } = props;
  const formRef = useRef(null);
  const [cropping, setCropping] = useState(false);
  const [file, setFile] = useState(null);
  const [imgUrl, setImgUrl] = useState();

  /**
   * Create Default Image
   * */
  useEffect(() => {
    const { GroupId, Sub } = props.currentUser;
    if (!GroupId || !Sub) return;
    const url = encodeURI(
      `https://ptwired-exercise-images-prod.s3.amazonaws.com/${GroupId}/${Sub}.jpg`
    );

    setImgUrl(url.replace('@', '%40'));
  }, []);

  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  function beforeUpload(file) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('Image must smaller than 2MB!');
    }
    return isJpgOrPng && isLt2M;
  }

  const [imageLoading, setImageLoading] = useState(false);

  const handleChange = info => {
    if (info.file.status === 'uploading') {
      setImageLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file, imageUrl => {
        setImgUrl(imageUrl);
        setImageLoading(false);
      });
    }
  };

  const handleImage = params => {
    setFile(params.file);
    setCropping(true);
  };

  const updateImage = blob => {
    uploadImage(blob)
      .then(({ value }) => {
        if (value.message === 'Success') {
          const image = new Image();
          const src = URL.createObjectURL(blob);
          image.src = src;
          setImgUrl(src);
          // formRef.appendChild(image);

          setImageLoading(false);
          message.success('Image Upload Successful!');
        }
      })
      .catch(err => {
        console.log(err);
        message.error(
          "We couldn't update your image. Please Contact Customer Service."
        );
      });
  };

  const isActive = value => {
    if (value === true || value === 'true') {
      return true;
    } else if (value === false || value === 'false') {
      return false;
    } else return true;
  };

  const checkAdmin = value => {
    if (value === GA) {
      return true;
    } else if (value === PT) {
      return false;
    } else return false;
  };

  const {
    initialValues: {
      Active,
      BillingRole,
      EmailAddress,
      FirstName,
      LastName,
      Role,
      PartTime
    }
  } = props;

  const [firstName, setFirstName] = useState(FirstName);
  const [lastName, setLastName] = useState(LastName);
  const [emailAddress, setEmailAddress] = useState(EmailAddress);
  const [billingRole, setBillingRole] = useState(BillingRole);
  const [role, setRole] = useState(Role ? Role : PT);
  const [active, setActive] = useState(Active ? isActive(Active) : true);
  const [emailError, setEmailError] = useState(false);
  const [partTime, setPartTime] = useState(PartTime || false);

  let incomplete = !firstName || !lastName || !emailAddress || !billingRole;
  let notEdited =
    FirstName === firstName &&
    LastName === lastName &&
    EmailAddress === emailAddress &&
    BillingRole === billingRole &&
    Role === role &&
    isActive(Active) === active &&
    PartTime === partTime;

  const updateRole = value => {
    /**
     * Flip role
     */
    if (value === 'pt') {
      setRole('ga');
    } else {
      setRole('pt');
    }
  };

  const checkEmail = value => {
    if (
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        value
      )
    ) {
      setEmailError(false);
    } else {
      setEmailError(true);
    }
  };

  const submitEmail = v => {
    const address = v.target.value.trim().toLowerCase();
    checkEmail(address);
    setEmailAddress(address);

    validateUserEmail(address);
  };

  const [uniqueEmail, setUniqueEmail] = useState(true);
  const validateUserEmail = async email => {
    const validation = await props.dispatch(
      getUser(props.visibleProfile.GroupInfo.Name, email)
    );

    if (validation.value && validation.value.message === 'User not found') {
      setUniqueEmail(true);
    } else {
      setUniqueEmail(false);
    }
  };

  const submit = () => {
    const { initialValues } = props;
    const { GroupId } = props.visibleProfile;

    const form = {
      Sub: initialValues.Sub,
      FirstName: firstName,
      LastName: lastName,
      EmailAddress: emailAddress,
      BillingRole: billingRole,
      Role: role,
      Active: active,
      firstName: firstName,
      lastName: lastName,
      emailAddress: emailAddress,
      billingRole: billingRole,
      role: role,
      active: active,
      groupId: GroupId,
      GroupId: GroupId,
      PartTime: partTime,
      isEmailChanged: initialValues.EmailAddress !== emailAddress
    };

    onSubmit(form);
  };

  const uploadButton = (
    <div>
      {imageLoading ? <LoadingOutlined /> : <PlusOutlined />}

      <div className="ant-upload-text">Upload Profile Image</div>
    </div>
  );

  return (
    <div>
      <Form
        name={'user-form'}
        layout={'horizontal'}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 12 }}
      >
        {cropping && (
          <ProfileImage
            show={cropping}
            onHide={() => {}}
            image={file}
            onSubmit={val => {
              updateImage(val);
            }}
            closeButton={() => {
              setCropping(false);
            }}
            onExit={() => setCropping(false)}
          />
        )}
        {props.currentUser && props.currentUser.EmailAddress && (
          <Form.Item name={'imageSelector'} style={{ marginLeft: '45%' }}>
            <Upload
              name="avatar"
              listType="picture-card"
              className="avatar-uploader"
              showUploadList={false}
              beforeUpload={beforeUpload}
              onChange={handleChange}
              customRequest={params => handleImage(params)}
            >
              {imgUrl ? (
                <img
                  src={imgUrl}
                  alt="avatar"
                  style={{ width: '100%' }}
                  onError={() => setImgUrl(null)}
                />
              ) : (
                uploadButton
              )}
            </Upload>
          </Form.Item>
        )}

        <Form.Item name={'firstName'} label={'First Name'}>
          <Input
            placeholder={'First Name'}
            defaultValue={FirstName}
            onChange={v => setFirstName(v.target.value.trim())}
            value={firstName}
          />
        </Form.Item>
        <Form.Item name={'lastName'} label={'Last Name'}>
          <Input
            placeholder={'Last Name'}
            defaultValue={LastName}
            onChange={v => setLastName(v.target.value.trim())}
            value={lastName}
          />
        </Form.Item>

        <Form.Item
          name={'emailAddress'}
          label={'Email Address'}
          validateStatus={
            emailError || !uniqueEmail
              ? 'error'
              : emailAddress
              ? 'success'
              : null
          }
          help={!uniqueEmail ? 'Email must be unique' : null}
        >
          <Input
            placeholder={'Email Address'}
            defaultValue={EmailAddress}
            onChange={submitEmail}
            value={emailAddress}
          />
        </Form.Item>

        <Form.Item name="billingRole" label={'Billing Role'}>
          <Select
            placeholder="Billing Role"
            value={getBillingRole(billingRole)}
            defaultValue={getBillingRole(billingRole)}
            onChange={v => setBillingRole(v)}
          >
            <Option value={'PT'}>Provider</Option>
            <Option value={'PTA'}>Provider Assistant</Option>
            <Option value={'TECH'}>Technician</Option>
          </Select>
        </Form.Item>

        <Form.Item name="parttime" label="Part-Time">
          <Switch checked={partTime} onChange={val => setPartTime(val)} />
        </Form.Item>

        <Form.Item
          name="administrator"
          label="Administrator"
          valuePropName="checked"
        >
          <Switch
            defaultChecked={checkAdmin(role)}
            onClick={() => updateRole(role)}
            checked={checkAdmin(role)}
          />
        </Form.Item>

        <Form.Item name="active" label="Active" valuePropName="checked">
          <Switch
            defaultChecked={isActive(active)}
            onClick={() => setActive(!active)}
            checked={isActive(active)}
          />
        </Form.Item>
        {/* {`You're about to deactivate this account.\nDeactivating it will archive all the messages.\nDo you want to continue?`} */}
        <Form.Item name={'submit'} wrapperCol={{ span: 4, offset: 12 }}>
          {!active ? (
            <Popconfirm
              title={
                <Typography.Text>
                  <strong>Deactivate Account?</strong>
                  <br />
                  Deactivating the account will archive all of it's message
                  conversations.
                  <br />
                  Do you want to continute?
                </Typography.Text>
              }
              okText="Deactivate"
              cancelText="Cancel"
              onConfirm={() => submit()}
              okButtonProps={{
                danger: true
              }}
            >
              <Button
                type="primary"
                disabled={
                  submitting ||
                  emailError ||
                  !uniqueEmail ||
                  incomplete ||
                  notEdited
                }
              >
                {!submitting ? 'Save' : <Spin />}
              </Button>
            </Popconfirm>
          ) : (
            <Button
              type="primary"
              disabled={
                submitting ||
                emailError ||
                !uniqueEmail ||
                incomplete ||
                notEdited
              }
              onClick={() => submit()}
            >
              {!submitting ? 'Save' : <Spin />}
            </Button>
          )}
        </Form.Item>
      </Form>
      <div ref={formRef} style={{ display: 'none' }}></div>
    </div>
  );
}
function mapStateToProps(state) {
  return {
    currentUser: state.users.currentUser,
    visibleProfile: state.visibleProfile
  };
}

export default connect(mapStateToProps)(UserForm);
